/**
 * Full A4 report PDF (waiters + days tables).
 */

import html2pdf from 'html2pdf.js';
import { fmtPLN, todayISO, waiterFullName } from './helpers';

export const generateReportPDF = async ({
  filteredEntries,
  waiterById,
  overallTotals,
  waiterTotals,
  dailyTotals,
  fromDate,
  toDate,
  logoUrl,
}) => {
  const totals = overallTotals(filteredEntries);
  const wTotals = waiterTotals(filteredEntries).filter((t) => t.count > 0);
  const dTotals = dailyTotals(filteredEntries);
  const rangeLabel = fromDate || toDate ? `${fromDate || '...'} → ${toDate || '...'}` : 'Wszystkie dane';

  const waiterRows = wTotals
    .map((t) => {
      const w = waiterById.get(t.waiterId);
      return `<tr>
        <td style="padding:12px;border:1px solid #ddd;text-align:left">${w ? waiterFullName(w) : '?'}</td>
        <td style="padding:12px;border:1px solid #ddd;text-align:right;font-weight:bold">${fmtPLN(t.amount)} zł</td>
        <td style="padding:12px;border:1px solid #ddd;text-align:right;color:#16a34a">${fmtPLN(t.waiter)} zł</td>
        <td style="padding:12px;border:1px solid #ddd;text-align:right;color:#2563eb">${fmtPLN(t.kitchen)} zł</td>
        <td style="padding:12px;border:1px solid #ddd;text-align:center">${t.count}</td>
      </tr>`;
    })
    .join('');

  const dayRows = dTotals
    .map(
      (d) => `<tr>
      <td style="padding:12px;border:1px solid #ddd;text-align:left;font-weight:bold">${d.date}</td>
      <td style="padding:12px;border:1px solid #ddd;text-align:right;font-weight:bold">${fmtPLN(d.amount)} zł</td>
      <td style="padding:12px;border:1px solid #ddd;text-align:right;color:#16a34a">${fmtPLN(d.waiter)} zł</td>
      <td style="padding:12px;border:1px solid #ddd;text-align:right;color:#2563eb">${fmtPLN(d.kitchen)} zł</td>
      <td style="padding:12px;border:1px solid #ddd;text-align:center">${d.count}</td>
    </tr>`
    )
    .join('');

  const html = `
    <div style="font-family:Arial,sans-serif;padding:30px;max-width:800px;color:#1a1a1a;background:#fff">
      <div style="text-align:center;border-bottom:3px solid #d4af37;padding-bottom:20px;margin-bottom:25px">
        <img src="${logoUrl}" style="width:80px;height:80px;border-radius:50%"/>
        <h1 style="margin:15px 0 5px;font-size:28px;color:#1a1a1a">MR JERRY</h1>
        <p style="color:#666;margin:0;font-size:14px">Raport napiwków (Kelner 60% / Kuchnia 40%)</p>
        <p style="color:#888;margin:8px 0 0;font-size:12px">Zakres: ${rangeLabel}</p>
        <p style="color:#888;margin:5px 0 0;font-size:11px">Wygenerowano: ${new Date().toLocaleString()}</p>
      </div>
      <div style="background:#f8f9fa;border:2px solid #d4af37;border-radius:12px;padding:25px;margin-bottom:30px">
        <h2 style="margin:0 0 20px;font-size:18px;color:#333;text-align:center">PODSUMOWANIE</h2>
        <table style="width:100%;border-collapse:collapse">
          <tr>
            <td style="padding:15px;text-align:center;width:25%">
              <div style="font-size:28px;font-weight:bold;color:#d4af37">${fmtPLN(totals.amount)} zł</div>
              <div style="font-size:12px;color:#666;margin-top:5px">SUMA NAPIWKÓW</div>
            </td>
            <td style="padding:15px;text-align:center;width:25%">
              <div style="font-size:24px;font-weight:bold;color:#16a34a">${fmtPLN(totals.waiter)} zł</div>
              <div style="font-size:12px;color:#666;margin-top:5px">KELNERZY (60%)</div>
            </td>
            <td style="padding:15px;text-align:center;width:25%">
              <div style="font-size:24px;font-weight:bold;color:#2563eb">${fmtPLN(totals.kitchen)} zł</div>
              <div style="font-size:12px;color:#666;margin-top:5px">KUCHNIA (40%)</div>
            </td>
            <td style="padding:15px;text-align:center;width:25%">
              <div style="font-size:24px;font-weight:bold;color:#333">${totals.count}</div>
              <div style="font-size:12px;color:#666;margin-top:5px">WPISÓW</div>
            </td>
          </tr>
        </table>
      </div>
      <h3 style="font-size:16px;color:#333;margin:25px 0 15px;padding-bottom:8px;border-bottom:2px solid #eee">PODSUMOWANIE KELNERÓW</h3>
      <table style="width:100%;border-collapse:collapse;font-size:14px">
        <thead>
          <tr style="background:#d4af37">
            <th style="padding:14px;text-align:left;color:#000;font-weight:bold;border:1px solid #c9a230">Kelner</th>
            <th style="padding:14px;text-align:right;color:#000;font-weight:bold;border:1px solid #c9a230">Suma</th>
            <th style="padding:14px;text-align:right;color:#000;font-weight:bold;border:1px solid #c9a230">Kelner 60%</th>
            <th style="padding:14px;text-align:right;color:#000;font-weight:bold;border:1px solid #c9a230">Kuchnia 40%</th>
            <th style="padding:14px;text-align:center;color:#000;font-weight:bold;border:1px solid #c9a230">Wpisów</th>
          </tr>
        </thead>
        <tbody>
          ${waiterRows || '<tr><td colspan="5" style="padding:20px;text-align:center;color:#666;border:1px solid #ddd">Brak danych</td></tr>'}
        </tbody>
      </table>
      <h3 style="font-size:16px;color:#333;margin:30px 0 15px;padding-bottom:8px;border-bottom:2px solid #eee">PODSUMOWANIE DNI</h3>
      <table style="width:100%;border-collapse:collapse;font-size:14px">
        <thead>
          <tr style="background:#d4af37">
            <th style="padding:14px;text-align:left;color:#000;font-weight:bold;border:1px solid #c9a230">Data</th>
            <th style="padding:14px;text-align:right;color:#000;font-weight:bold;border:1px solid #c9a230">Suma</th>
            <th style="padding:14px;text-align:right;color:#000;font-weight:bold;border:1px solid #c9a230">Kelnerzy 60%</th>
            <th style="padding:14px;text-align:right;color:#000;font-weight:bold;border:1px solid #c9a230">Kuchnia 40%</th>
            <th style="padding:14px;text-align:center;color:#000;font-weight:bold;border:1px solid #c9a230">Wpisów</th>
          </tr>
        </thead>
        <tbody>
          ${dayRows || '<tr><td colspan="5" style="padding:20px;text-align:center;color:#666;border:1px solid #ddd">Brak danych</td></tr>'}
        </tbody>
      </table>
      <div style="margin-top:40px;padding-top:20px;border-top:2px solid #eee;text-align:center;color:#888;font-size:11px">
        <p style="margin:0">MR JERRY • System zarządzania napiwkami</p>
        <p style="margin:5px 0 0">Kelner 60% / Kuchnia 40%</p>
      </div>
    </div>
  `;

  const container = document.createElement('div');
  container.innerHTML = html;
  document.body.appendChild(container);
  await html2pdf()
    .set({
      margin: 15,
      filename: `mrjerry-raport-${todayISO()}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, logging: false },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    })
    .from(container.firstElementChild)
    .save();
  document.body.removeChild(container);
};
